import { render } from "./FruitIframe.vue?vue&type=template&id=ec1bf108"
import script from "./FruitIframe.vue?vue&type=script&lang=js"
export * from "./FruitIframe.vue?vue&type=script&lang=js"
script.render = render

export default script